import React, {useEffect} from 'react';
import classNames from 'classnames/bind';
import { displayValueWithSymbol } from '../../../utils/price';
import styles from './index.pcss';
import { replaceWithJioCDN } from '../../../utils/imageHandling';
import { gtmEventPush, segmentEventPush } from '../../../modules/ga/GTMdatalayer';
const cx = classNames.bind(styles);

const OrderSummaryWithMOPs = ({optedPaymentModeOrderList = [], code , orderStatus = ''}) => {

  useEffect(() => {
    const options = {
      root: null, // Use the viewport as the root
      rootMargin: '0px', // No margin
      threshold: 0.5 // Trigger when 50% of the slide is visible
    };
    let mopSummaryWidget = document.getElementById(`odp_paymentmode`);
    const hasValidSavedMop = optedPaymentModeOrderList?.some(
      (item) => item.savedMop && item.savedMop.trim() !== ''
    );
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        if (sessionStorage.getItem('odp_paymentmode') !== 'true') {
          gtmEventPush({
            event: 'order_item_details_interaction',
            event_category: 'order item details interaction',
            event_label: hasValidSavedMop ? 'payment saved' : 'payment not saved',
            event_action: 'payment mode section viewed',
            order_id: code,
            page_name: 'order item details screen',
            page_type: 'order item details screen '
          });
          // Segment Push Event
          segmentEventPush({
            event: 'Payment Mode Seen',
            event_category: 'order item details interaction',
            event_label: hasValidSavedMop ? 'payment saved' : 'payment not saved',
            event_action: 'payment mode section viewed',
            order_id: code,
            order_status: orderStatus,
            screen_name: 'order item details screen',
            // page_type: 'order item details screen '
          });
          sessionStorage.setItem('odp_paymentmode', 'true');
        }
      }
    }, options);

    if (mopSummaryWidget) {
      observer.observe(mopSummaryWidget);
    }
    window.addEventListener('beforeunload', () => {
      sessionStorage.removeItem(`odp_paymentmode`)
     });
     return () => {
      observer.disconnect();
    };
  }, [optedPaymentModeOrderList]);
 
  console.log('optedPaymentModeOrderList', optedPaymentModeOrderList);
  return (
    <ul id="odp_paymentmode">
      {optedPaymentModeOrderList?.map(mopItem => (
        <li className={cx('mop-container')}>
          <div className={cx('mop-details')}>
            {mopItem?.logo && (
              <div className={cx("mop-img")}>
                <img src={replaceWithJioCDN(mopItem?.logo)} />
              </div>
            )}
            <div className={cx('mop-name')}>
              {mopItem?.modeOfPaymentName}
              <div className={cx('mop-masked-digits')}>{mopItem?.maskedDigits}</div>
            </div>
          </div>
          <div>{displayValueWithSymbol(Math.abs(Number(mopItem?.amount)).toFixed(2))}</div>
        </li>
      ))}
    </ul>
  );
};

export default OrderSummaryWithMOPs;
